import { FC } from 'react';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import Skeleton from 'react-loading-skeleton';
import { CognitoTokenManager } from 'app/modules/auth';
import AnalyticsReportPreviewFailedMessage from 'app/modules/analytics/modules/reports/components/reportPreview/AnalyticsReportPreviewFailedMessage';
import { fetchAnalyticsReportPublicPreview } from 'app/modules/analytics/modules/reports/utils/resolveAnalyticsReportPublicPreviewAuth';
import { queryKey } from 'constants/queryKey';
import AnalyticsReportPublicPage, {
  type AnalyticsReportPublicMode,
} from './AnalyticsReportPublicPage';

const AnalyticsReportPublicRoute: FC = () => {
  const { id } = useParams();
  const [params] = useQueryParams({
    token: StringParam,
    accountId: NumberParam,
    mode: StringParam,
  });
  const tokenFromUrl = params.token;
  const accountId = params.accountId ?? undefined;
  const mode = params.mode as AnalyticsReportPublicMode | null | undefined;
  const reportId = Number(id);
  const isFiniteReportId = Number.isFinite(reportId);
  const hasUrlToken = !!tokenFromUrl;
  const hasStoredSessionToken = !!CognitoTokenManager.getAccessTokenSync();

  const { isLoading, data, isError } = useQuery(
    queryKey.analyticsReportPreview(reportId),
    () => fetchAnalyticsReportPublicPreview(reportId, tokenFromUrl, accountId),
    {
      enabled: isFiniteReportId && (hasUrlToken || hasStoredSessionToken),
      retry: false,
    },
  );

  if (!isFiniteReportId || (!hasUrlToken && !hasStoredSessionToken)) {
    return <AnalyticsReportPreviewFailedMessage />;
  }

  if (isLoading) {
    return <Skeleton width="100%" height="200px" />;
  }

  if (isError || !data) {
    return <AnalyticsReportPreviewFailedMessage />;
  }

  return <AnalyticsReportPublicPage preview={data} mode={mode} />;
};

export default AnalyticsReportPublicRoute;
